import { render } from "./OtamericaUnited.vue?vue&type=template&id=e45c6c06"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__